<template>
    <div>
        <b-button variant="dark" @click="show = true"><i class="fa fa-bars"></i> </b-button>
        <b-modal title="Controlls" v-model="show">
            <b-list-group>
              <b-list-group-item v-for="key in Object.keys(keys)" :key="key">
                <template>
                    <strong>{{ key }}</strong>  <i> {{ keys[key] }}</i>
                </template>
              </b-list-group-item>
            </b-list-group>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "Controls",
    props: {
        keys: {
            type: Object
        },
    },
    data: function() {
        return {
            show: false
        }
    },
    computed: {
        items() {
            return this.keys;
        }
    },
}
</script>